// Terms version constant
// Update this when terms of service or privacy policy change
export const TERMS_VERSION = "1.0";

